import { SxProps } from '@mui/material';

export const topContennt: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};
export const sysName: SxProps = {
  display: 'inline-block',
  color: 'primary.contrastText',
  marginRight: 1,
};
export const version: SxProps = {
  display: 'none',
  color: 'primary.contrastText',
};
export const company: SxProps = {
  color: 'primary.contrastText',
  paddingLeft: 1,
};
